<template>
    <div class="survey-list md-scrollbar md-theme-default">
        <div class="survey-list__container">
            <div class="survey-list__container__header">
                <span>{{formatPossibleSurveyNamePart1(selectedSurvey.name)}}<br>
                      {{formatPossibleSurveyNamePart2(selectedSurvey.name)}}</span>
            </div>
            <md-content v-bind:class="{ 'md-scrollbar md-theme-default': $mq !== 'xs' }">
                <transition-group name="fade">
                    <div class="survey-list__container__field"
                         v-for="(child, index) in field.children"
                         v-bind:key="index" v-bind:field="child"
                         @click="onSelectElement(child, index)"
                         v-if="
                         (!showOnlyFilled || (showOnlyFilled && child.completed))
                         && (showAllListElements
                         || index === selectedListElementIndex
                         || (selectedListElementIndex === null && index === 0))"
                         v-bind:class="{
                           'active': index === selectedListElementIndex,
                           'expanded': showAllListElements
                         }">
                        <div class="survey-list-element"
                             v-bind:class="{ completed: child.completed }" 
                        >
                            <span>{{child.name}}</span>
                            <md-icon class="completed-check" v-if="child.completed"
                                     :md-src="require('../../assets/ic_checkmark_gray.svg')"/>
                        </div>
                    </div>
                </transition-group>
            </md-content>
            <mq-layout mq="xs">
                <btn v-if="showAllListElements" @click="toggleListLength()"
                     text="MNIEJ" class="btn-text survey-list__toggle-btn"
                     materialIconName="keyboard_arrow_up"></btn>
                <btn v-if="!showAllListElements" @click="toggleListLength()"
                     text="WIĘCEJ" class="btn-text survey-list__toggle-btn"
                     materialIconName="keyboard_arrow_down"></btn>
            </mq-layout>
        </div>
        <md-content class="survey-list__selected-container" v-if="selectedListElement"
                    v-bind:class="{ 'md-scrollbar md-theme-default': $mq !== 'xs' }"
                    :disabled="readonlyMode">
            <div v-for="(child, index) in selectedListElement.children"
                v-bind:key="index">
                <survey-field v-bind:field="child" v-bind:key="child.id" v-bind:class="{'biggerArea' : selectedListElement.children.length < 2}"
                              @nodeChange="onNodeChange"
                ></survey-field>
            </div>
        </md-content>
        <div v-if="!selectedListElement" class="chose-list-item-container">
            <mq-layout mq="xs">
                <div class="img_list_mobile_container">
                    <img class="img_list_mobile_container__arrow" src="../../assets/ic_arrow.svg">
                    <img class="img_list_mobile_container__checklist" src="../../assets/Ic_checklist_v2.svg">
                </div>
                <p v-if="!readonlyMode">Wybierz pozycję,<br>którą chcesz uzupełnić.</p>
                <p v-if="readonlyMode">Wykonane badania.</p>
            </mq-layout>
            <mq-layout :mq="['sm', 'md', 'lg', 'xl']">
                <div class="img_list_desktop_container">
                    <img class="img_list_desktop_container__arrow" src="../../assets/ic_arrow.svg">
                    <img class="img_list_desktop_container__checklist" src="../../assets/Ic_checklist_v2.svg">
                </div>
                <p v-if="!readonlyMode">Wybierz pozycję,<br>którą chcesz uzupełnić.</p>
                <p v-if="readonlyMode">Wykonane badania.</p>
            </mq-layout>
        </div>
    </div>
</template>

<script>
import store from '../../store';
import {checkListElementCompleteness} from '../../app-func';
// import { SURVEY_SELECT } from '../../store/action-modulation.type';

export default {
  name: 'SurveyList',
  props: ['field'],
  data: () => ({
    selectedSurvey: store.state.visit.selectedSurvey,
    selectedListElement: null,
    selectedListElementIndex: null,
    showAllListElements: true,
    readonlyMode: store.state.visit.readonlyMode,
    showOnlyFilled: store.state.visit.showOnlyFilled,
  }),
  methods: {
    formatPossibleSurveyNamePart1(name) {
      const n = name.indexOf('-');
      if (n > 0) {
        name = name.charAt(0).toUpperCase() + name.substring(1);
        const name1 = name.substr(0, n + 1);
        const result = name1;
        return result;
      }
      return name;
    },
    formatPossibleSurveyNamePart2(name) {
      const n = name.indexOf('-');
      if (n > 0) {
        name = name.charAt(0).toUpperCase() + name.substring(1);
        const name2 = name.substr(n + 1);
        const result = name2;
        return result;
      }
      return null;
    },
    checkElementCompleteness() {
      let completeFlag = true;

      this.field.children[this.selectedListElementIndex].children.forEach((el) => {
        if (!el.completed) completeFlag = false;
      });

      this.field.children[this.selectedListElementIndex].completed = completeFlag;
    },
    onNodeChange() {
      this.$forceUpdate();
      // this.field.children[this.selectedListElementIndex].children = this.field
      //   .children[this.selectedListElementIndex]
      //   .children.map(el => (node.id === el.id ? node : el));
      // this.checkElementCompleteness();
      this.checkListCompleteness();
    },
    onSelectElement(el, index) {
      this.selectedListElement = el;
      this.selectedListElementIndex = index;
      if (this.$mq === 'xs') {
        this.showAllListElements = false;
      }
    },
    toggleListLength() {
      this.showAllListElements = !this.showAllListElements;
    },
    checkListCompleteness() {
      this.field.children.forEach((listElement, index) => {
        let completeFlag = checkListElementCompleteness(listElement);

        this.field.children[index].completed = completeFlag;
        this.$forceUpdate();
      });
    },
  },
  computed: {
    getSelectedSurvey() {
      return store.state.visit.selectedSurvey;
    },
  },
  watch: {
    getSelectedSurvey(newCount) {
      this.selectedSurvey = newCount;
      this.selectedListElement = null;
      this.selectedListElementIndex = null;
      this.showAllListElements = true;
      this.checkListCompleteness();
    },
  },
  created() {
    this.checkListCompleteness();
  },
};
</script>

<style src="./SurveyList.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyList/SurveyList.vue